export default "__VITE_ASSET__Puk$X8Nm__"